module.exports = __webpack_public_path__ + "img/inverter_online.60c46041.png";